import 'pages/images/images-gallery-modal.tag'
riot.tag2('image-select', '  <div class="image" riot-style="background-image: url({item.imageUrlPreview.replaceAll(&quot; &quot;,&quot;%20&quot;)});">\n    <div class="image-select text-center" if="{uploadStatus === 0}">\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0100&quot;)}">\n        <div class="input-group btn btn-sm btn-primary btn-file" style="margin: 0 auto;">\n          <input onchange="{upload}" type="file" accept="image/*"><i class="fa fa-fw fa-upload"></i> Загрузить\n        </div>\n      </div>\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0010&quot;)}">\n        <button class="btn btn-sm btn-success" onclick="{select}" type="button"><i class="fa fa-fw fa-picture-o"></i> Выбрать</button>\n      </div>\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0010&quot;)}">\n        <button class="btn btn-sm btn-danger" onclick="{remove}" type="button"><i class="fa fa-fw fa-trash"></i> Очистить</button>\n      </div>\n    </div>\n    <div class="image-upload text-center" if="{uploadStatus &gt; 0}">\n      <h3 class="image-upload-percent">{uploadStatus}%</h3>\n    </div>\n  </div>\n', 'image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ display: table; position: relative; background-position: center; background-repeat: no-repeat; background-size: cover; width: 100%; height: 170px; } @media (max-width: 991px) { image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ margin: 0 auto; height: 450px !important; width: 450px !important; } } @media (max-width: 767px) { image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ margin: 0 auto; height: 300px !important; width: 300px !important; } } @media (max-width: 480px) { image-select .image,[riot-tag="image-select"] .image,[data-is="image-select"] .image{ margin: 0 auto; height: 240px !important; width: 240px !important; } } image-select .image .image-select,[riot-tag="image-select"] .image .image-select,[data-is="image-select"] .image .image-select{ display: none; } image-select .image:hover .image-select,[riot-tag="image-select"] .image:hover .image-select,[data-is="image-select"] .image:hover .image-select,image-select .image:focus .image-select,[riot-tag="image-select"] .image:focus .image-select,[data-is="image-select"] .image:focus .image-select{ display: table-cell; vertical-align: middle; background-color: rgba(0, 0, 0, 0.5); } image-select .image-upload,[riot-tag="image-select"] .image-upload,[data-is="image-select"] .image-upload{ display: table-cell; vertical-align: middle; } image-select .image-upload-percent,[riot-tag="image-select"] .image-upload-percent,[data-is="image-select"] .image-upload-percent{ color: #FFF; text-shadow: 0 0 1px black, 1px 1px 2px black; }', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.uploadStatus = 0;
self.item = {};

function changeEvent() {
    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
}

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.item.image;
    },
    set: function set(value) {
        console.log(value);

        self.item.image = value;
        self.item.imageFile = 'images/' + opts.section + '/' + value;
        self.item.imageUrlPreview = app.getImagePreviewURL(value, opts.section, opts.size);
    }
});

self.upload = function (e) {
    var formData = new FormData();

    for (var i = 0; i < e.target.files.length; i++) {
        formData.append('file' + i, e.target.files[i], e.target.files[i].name);
    }

    API.upload({
        section: opts.section,
        count: 1,
        data: formData,
        progress: function progress(e) {
            var percentComplete = Math.ceil(e.loaded / e.total * 100);
            self.uploadStatus = percentComplete;
            self.update();
        },
        success: function success(response) {
            self.item.image = response.items[0].name;
            changeEvent();
            self.update();
        },
        complete: function complete() {
            self.uploadStatus = 0;
            self.update();
        }
    });
};

self.select = function () {
    modals.create('images-gallery-modal', {
        type: 'modal-primary',
        section: opts.section,
        submit: function submit() {
            var items = this.tags.gallery.tags.datatable.getSelectedRows();

            if (items.length) {
                self.item.image = items[0].name;
                changeEvent();
                self.update();
            }

            this.modalHide();
        }
    });
};

self.remove = function () {
    self.item.image = '';
    self.item.imageFile = '';
    self.item.imageUrlPreview = '';
    changeEvent();
};

self.on('mount', function () {
    self.root.name = opts.name;
});
});


// WEBPACK FOOTER //
// ./pages/images/image-select.tag